import React from 'react';
import { CaseStudyPage } from './pages/CaseStudyPage';
export function App() {
  return <CaseStudyPage data-id="element-0" />;
}